import _cx from 'classnames';
import React, { useEffect, useState, useRef } from 'react';
import { Portal } from 'react-portal';
import { CSSTransition } from 'react-transition-group';
import _ from 'lodash';

// Helpers
import { getSuccessIcon, getWarningIcon, getCloseIcon } from '../utils/helpers';

const Modal = ({id, type, description, heading, isOpened, onClick: handleClick, children}: any) => {

    const modalRef = useRef<any>(null);

    const getModalContent = () => {

        let modalContent = null;
 
        switch ( type ) {
            
            case 'confirm':

                modalContent = (
                    <>
                        <div className="modal__icon">
                            { getWarningIcon() }
                        </div>

                        <h2 className="modal__heading">
                            {heading}
                        </h2>

                        <p className="modal__description">
                            {description}
                        </p>

                        <div className="modal__actions">
                            <button className="es-button es-button--cta" data-name={'no'} onClick={handleClick}>Nie</button>
                            <button className="es-button" data-name={'yes'} onClick={handleClick}>Áno</button>
                        </div>
                    </>
                )
                
                break; 

            case 'info':

                modalContent = (
                    <>

                        <div className="modal__icon">
                            { getSuccessIcon() }
                        </div>

                        <h2 className="modal__heading">
                            {heading}
                        </h2>

                        <p className="modal__description">
                            {description}
                        </p>

                        <div className="modal__actions">
                            <button className="es-button es-button--cta" data-name={'close'} onClick={handleClick}>Pokračovať na stránku</button>
                        </div>
                    </>
                )
                
                break;

            case 'error':

                modalContent = (
                    <>

                        <div className="modal__icon">
                            { getWarningIcon() }
                        </div>

                        <h2 className="modal__heading">
                            {heading}
                        </h2>

                        <p className="modal__description">
                            {description}
                        </p>

                        <div className="modal__actions">
                            <button className="es-button es-button--cta" data-name={'close'} onClick={handleClick}>Pokračovať</button>
                        </div>
                    </>
                )
                
                break;

            case 'custom':

                modalContent = (
                    <>
                        
                        <div className="modal__header">
                            <h2 className="modal__heading">
                                {heading}
                            </h2>
                            <div className="wooptima-button--close" data-name={'close'} onClick={handleClick}>{getCloseIcon()}</div>
                        </div>

                        {children}
                    </>
                )
                
                break;

        }

        return modalContent;

    }

    useEffect(() => {
        if ( isOpened ) {
            modalRef.current.focus();
        }
        document.body.classList.toggle('es-scroll--disabled', isOpened);
    }, [isOpened])
    
    return (
        <CSSTransition mountOnEnter unmountOnExit in={isOpened} timeout={200}>
            <Portal>
                <div tabIndex={0} ref={modalRef} className={_cx('wooptima-modal', type)}>
                    <div id={`modal-${id}`} className="modal__content">
                        {getModalContent()}
                    </div>               
                </div>
            </Portal>
        </CSSTransition>
    );
 
} 

export default Modal; 